import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';

// Remove per AWS Amplify
// import { defineBackend } from '@aws-amplify/backend';
// defineBackend({});

Sentry.init({
  dsn:
    import.meta.env.ENV !== 'local-dev'
      ? 'https://bd5b991fbcd0ba4600f6997f9a883c7b@o4506813627170816.ingest.sentry.io/4506813684645888'
      : undefined,
  // dsn: 'https://bd5b991fbcd0ba4600f6997f9a883c7b@o4506813627170816.ingest.sentry.io/4506813684645888',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'light',
      formTitle: 'Provide Feedback',
      submitButtonLabel: 'Submit',
      buttonLabel: 'Provide Feedback',
      messagePlaceholder: 'What did you expect? What happened instead?',
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // TODO: Update the list of tracePropagationTargets to include the URLs of your backend services
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.dn20omngojdx8\.amplifyapp\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  initialScope: {
    tags: {
      build: `${import.meta.env.COMMIT_HASH}`,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
